<era-master-detail flexGrowLeft="1"
                   flexGrowRight="2">
  <era-master>
    <ml-mdm-devices-overview></ml-mdm-devices-overview>
  </era-master>
</era-master-detail>